import { css } from '@emotion/react';
import { theme } from './theme';
import { LinkStyle } from './LinkStyle';

export const GlobalStyle = css`
	html {
		font-size: 14px;
	}
	body,
	html {
		padding: 0;
		margin: 0;
		height: 100%;
	}
	body {
		font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu,
			Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
		font-size: 1rem;
		line-height: 20px;
		color: ${theme.color.text['400']};
	}

	strong {
		font-weight: bold;
	}

	html {
		-moz-osx-font-smoothing: grayscale;
		-webkit-font-smoothing: antialiased;
		font-smoothing: antialiased;

		-ms-text-size-adjust: 100%;
		-webkit-text-size-adjust: 100%;
	}

	#root {
		height: 100%;
	}

	a {
		text-decoration: none;
		${LinkStyle()}
	}
`;
